export default __webpack_public_path__ + "static/media/shop-store-icon.bab7bc08.svg";